import * as React from "react"

import { APARENCIA_DE_CAMPO, DIGITADO_EM_MAIUSCULAS } from "../lib/classes"
import { cn } from "../lib/cn"

function Textarea({
  className,
  maiusculas = true,
  ...props
}: React.ComponentProps<"textarea"> & { maiusculas?: boolean }) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "min-h-20 w-full min-w-0 resize-y border border-input px-3 py-2 text-base text-foreground transition-[color,box-shadow] outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:text-muted-foreground md:text-sm",
        APARENCIA_DE_CAMPO,
        maiusculas && DIGITADO_EM_MAIUSCULAS,
        "focus-visible:border-ring",
        "aria-invalid:border-destructive",
        "user-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
